/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Grouping_Options_LabelInputs */

const en_transcript_export_grouping_options_label = /** @type {(inputs: Transcript_Export_Grouping_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grouping Options`)
};

const fr_transcript_export_grouping_options_label = /** @type {(inputs: Transcript_Export_Grouping_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options de regroupement`)
};

const de_transcript_export_grouping_options_label = /** @type {(inputs: Transcript_Export_Grouping_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppierungsoptionen`)
};

const it_transcript_export_grouping_options_label = /** @type {(inputs: Transcript_Export_Grouping_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzioni di raggruppamento`)
};

const ru_transcript_export_grouping_options_label = /** @type {(inputs: Transcript_Export_Grouping_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Параметры группировки`)
};

const es_transcript_export_grouping_options_label = /** @type {(inputs: Transcript_Export_Grouping_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones de agrupación`)
};

const zh_cn2_transcript_export_grouping_options_label = /** @type {(inputs: Transcript_Export_Grouping_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分组选项`)
};

const ja_transcript_export_grouping_options_label = /** @type {(inputs: Transcript_Export_Grouping_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループ化オプション`)
};

const hi_transcript_export_grouping_options_label = /** @type {(inputs: Transcript_Export_Grouping_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूहीकरण विकल्प`)
};

const pt_pt2_transcript_export_grouping_options_label = /** @type {(inputs: Transcript_Export_Grouping_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opções de agrupamento`)
};

/**
* | output |
* | --- |
* | "Grouping Options" |
*
* @param {Transcript_Export_Grouping_Options_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_grouping_options_label = /** @type {((inputs?: Transcript_Export_Grouping_Options_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Grouping_Options_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_grouping_options_label(inputs)
	if (locale === "de") return de_transcript_export_grouping_options_label(inputs)
	if (locale === "it") return it_transcript_export_grouping_options_label(inputs)
	if (locale === "ru") return ru_transcript_export_grouping_options_label(inputs)
	if (locale === "es") return es_transcript_export_grouping_options_label(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_grouping_options_label(inputs)
	if (locale === "ja") return ja_transcript_export_grouping_options_label(inputs)
	if (locale === "hi") return hi_transcript_export_grouping_options_label(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_grouping_options_label(inputs)
	return en_transcript_export_grouping_options_label(inputs)
});